<template>
    <div>
      <input type="file" @change="onFileChange" accept="image/*"/>
      <button @click="uploadImage">上传</button>
    </div>
  </template>
   
  <script>
  export default {
    data() {
      return {
        selectedFile: null,
      };
    },
    methods: {
      onFileChange(e) {
        this.selectedFile = e.target.files[0];
      },
      uploadImage() {
        if (!this.selectedFile) {
          alert('请选择文件');
          return;
        }
   
        const reader = new FileReader();
        reader.onload = (e) => {
          // 在这里可以处理FileReader读取的结果，例如显示图片预览或上传图片
          // 上传图片到服务器的代码放在这里
          console.log(e.target.result); // 打印出Base64编码的图片
        };
        reader.readAsDataURL(this.selectedFile);
      },
    },
  };
  </script>